import { ClientData } from '@core/models/client-data.model';
import { createAction, props } from '@ngrx/store';

export const clientDataEdit = createAction(
  '[ClientData] Client data changed',
  props<{ clientData: ClientData }>()
);

export const clientDataEditEncryptedToken = createAction(
  '[ClientData] Encrypted token changed',
  props<{ encryptedToken: string }>()
);
